export default (state = {}, {type, payload}) => {
	switch (type) {
		case 'SET_SIGNATURE':
			return {
				...state,
				[payload.id]: payload.value,
			}
		default:
			return state
	}
}
